import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { tabsClasses } from '@mui/material/Tabs';
import { Box, LinearProgress, Tab, Tabs, Typography } from '@mui/material';

import useNotification from '../../../../core/hooks/use_notification';
import { ROUTE_PRICE_LISTS } from '../../../../core/constants';
import { getPodsNotificationData, getPriceListNotificationData } from '../../../../core/utils/notification_utils';
import { getAllPodsAction, getAllPodsState } from '../../../../features/pod/get_all_pods';
import PageHeader from '../../../common/page_header';
import { getPriceListAction, getPriceListState } from '../../../../features/price/get_price_list';
import ProductsList from './products_list';
import PodsList from './pods_list';

const PriceListPage = () => {
    const { showErrorMessage } = useNotification();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { priceListId } = useParams();

    const getPriceList = useSelector(getPriceListState);
    const getAllPods = useSelector(getAllPodsState);

    const [tab, setTab] = useState(0);

    const refreshPriceList = useCallback(() => {
        priceListId && dispatch(getPriceListAction(priceListId))
            .then(response => showErrorMessage((getPriceListNotificationData(response))));
    }, [dispatch, priceListId, showErrorMessage]);

    useEffect(() => {
        dispatch(getAllPodsAction())
            .then(response => showErrorMessage(getPodsNotificationData(response)));
        refreshPriceList();
    }, [dispatch, refreshPriceList, showErrorMessage]);

    const renderView = () => {
        if (getPriceList?.loading || getAllPods?.loading) {
            return (
                <Box mt={ 6 }>
                    <LinearProgress/>
                </Box>
            );
        }

        if (getPriceList?.data && getAllPods?.data) {
            if (tab === 0) {
                return <ProductsList priceListId={ priceListId }/>;
            } else if (tab === 1) {
                return <PodsList podIds={ getPriceList?.data?.podIds } refreshPriceList={ refreshPriceList }/>;
            }
        }

        return <></>;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3 } }>
            <PageHeader
                title={ getPriceList?.data?.name }
                showBack={ true }
                onBack={ () => navigate(ROUTE_PRICE_LISTS) }
                titleAdornment={
                    <Typography variant="h6" color="textSecondary">
                        ID: { priceListId }
                    </Typography>
                }
            />

            <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
                <Tabs
                    value={ tab }
                    onChange={ (_, value) => setTab(value) }
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={ {
                        [`& .${ tabsClasses.scrollButtons }`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                    } }
                >
                    <Tab label="Produkty"/>
                    <Tab label="Punkty sprzedaży"/>
                </Tabs>
            </Box>

            <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1 } }>
                { renderView() }
            </Box>
        </Box>
    );
};

export default PriceListPage;